import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthRoutingModule } from './auth-routing.module';
import { OtpVerifyComponent } from './otp-verify/otp-verify.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AuthService } from './auth.service';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { SuccessAlert } from './change-password/change-password.component';
import { ChangePasswordSuccess } from './reset-password/reset-password.component';
import { InfoTimeup } from './change-password/change-password.component';
import { ChangePasswordSuccessLink, ChangePasswordSuccessLinkEmail } from './forget-password/forget-password.component';
import { RedirectComponent } from './redirect/redirect.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatToolbarModule,
  MatSidenavModule,
  MatProgressSpinnerModule } from '@angular/material';
import { RewardsComponent } from './rewards/rewards.component';
import { VerifyContactWarningComponent } from './verify-contact-warning/verify-contact-warning.component';
import { EmailOtpVerifyComponent } from './email-otp-verify/email-otp-verify.component';
import {CustomerEnrollModule} from '../customer-enroll/customer-enroll.module';
import {EmailValidationComponent} from '../email/email-validation.component';
import {PortableSignInComponent} from '../shared/portable-sign-in/portable-sign-in.component';
import {AccountPinValidatorComponent} from '../shared/account-pin-validator/account-pin-validator.component';
@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    AuthRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatToolbarModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
  ],
  providers: [AuthService],
  // tslint:disable-next-line:max-line-length
  declarations: [
    AccountPinValidatorComponent,
    PortableSignInComponent,
    EmailValidationComponent,
    OtpVerifyComponent,
    SignInComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    SuccessAlert,
    InfoTimeup,
    ChangePasswordSuccess,
    ChangePasswordSuccessLink,
    ChangePasswordSuccessLinkEmail,
    RedirectComponent,
    RewardsComponent,
    VerifyContactWarningComponent,
    EmailOtpVerifyComponent
  ],
  bootstrap: [SuccessAlert, InfoTimeup, ChangePasswordSuccess, ChangePasswordSuccessLink, ChangePasswordSuccessLinkEmail],
  exports: [
    AccountPinValidatorComponent,
    EmailOtpVerifyComponent,
    OtpVerifyComponent,
    EmailValidationComponent,
    PortableSignInComponent
  ]
})
export class AuthModule { }



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts